import type { PropRuntimeGraph } from "../../game/assets/shared/types/PropRuntimeGraph";
import type { RuntimePropInstance } from "../../game/assets/pri_wqs/scripts/core/propMechanics/PropMechanicsTypes";
import {
  FixedSlotGrid,
  InstanceCard,
  SandboxSection,
  SandboxSectionHeader,
} from "./styles";
import { PropCard } from "./PropCard";

export interface FixedSlotsPanelProps {
  title: string;
  items: RuntimePropInstance[];
  catalog?: PropRuntimeGraph[];
  slotCount: number;
  selectedId: string;
  onSelect: (item?: RuntimePropInstance, index?: number) => void;
  isEmptySlotInteractive?: (index: number) => boolean;
  enableMagicEffectAnchor?: boolean;
}

export function FixedSlotsPanel({
  title,
  items,
  catalog,
  slotCount,
  selectedId,
  onSelect,
  isEmptySlotInteractive,
  enableMagicEffectAnchor,
}: FixedSlotsPanelProps) {
  return (
    <SandboxSection $fixedHeight={96}>
      <SandboxSectionHeader>
        <span>{title}</span>
      </SandboxSectionHeader>
      <FixedSlotGrid $cols={slotCount}>
        {Array.from({ length: slotCount }, (_, index) => {
          const item = items[index];
          const emptyInteractive = !item && Boolean(isEmptySlotInteractive?.(index));
          return (
            <InstanceCard
              key={item?.id ?? `empty_${index}`}
              $active={item?.id === selectedId}
              $empty={!item}
              $emptyInteractive={emptyInteractive}
              $rarity={item?.graph.rarity}
              title={emptyInteractive ? "点击选择辅料" : undefined}
              onClick={() => onSelect(item, index)}
            >
              <PropCard
                item={item}
                catalog={catalog}
                empty={!item}
                imageSize={28}
                compact
                enableMagicEffectAnchor={enableMagicEffectAnchor}
              />
            </InstanceCard>
          );
        })}
      </FixedSlotGrid>
    </SandboxSection>
  );
}
